/* eslint-disable no-console */
/* eslint-disable guard-for-in */
/* eslint-disable max-len */
import { Button, Grid, Stack, Typography } from '@mui/material';
import React, { memo, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { FaPlus } from 'react-icons/fa6';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import FeedNodataImg from '../../../../../assets/NoDataImages/FeedNodataImg.svg';
import NoData from '../../../../../components/Common/NoData';
import { LanguageContext } from '../../../../../libs/Context';
import FeedCard from './Card';
import { useSelector } from 'react-redux';
import { getBookmarks, getFeedByCompanyId, getNewsFeeds, getPopularFeeds, getPendingApprovalFeeds } from '../../../../actions/feeds_actions_new';
import { catchErr, userFullName } from '../../../../../libs/HelperContent';
import useDidMountEffect from '../../../../../libs/CustomHooks/UseDidMountEffect';
import useInterSectionObserver from '../../../../../libs/CustomHooks/useIntersectionObserver';
import NewsFeedShimmer from '../../../../../components/Common/Shimmer/NewsFeedShimmer/NewsFeedShimmer';
import { feedActionContext } from '../../..';
import useDebounce from '../../../../../components/Hooks/useDebounce';
import { toast } from 'react-toastify';
import { feedActionContextFromExternal } from '../../ExternalRequest';
import CreationFieldPopUp from '../FeedCreation/CreationPopup';
import { Selected } from '../Connections/Activity';

export type From = 'business_profile' | 'network_profile' | 'my_profile';
interface Props
{
	scheduled?: boolean;
	selectedActivity?:Selected;
	requestT?:any;
	contextT?:string;
	searchVal?:string;
	from?:From;
	selectedFilter?:Array<any>;
	feedConnectionData?:any;
}
const FeedCards = (props:Props) =>
{
	const { scheduled = false, selectedActivity, requestT, contextT, searchVal = '', from, selectedFilter } = props;
	const type = useParams()?.type ?? 'feeds';
	const { language } = useContext(LanguageContext);
	const [ feedList, setFeedList ] = useState<any>([]);
	const [ count, setCount ] = useState({ feeds: 0, count: 0 });
	const [ loading, setLoading ] = useState(true);
	const [ page, setPage ] = useState(0);
	const debouncedSearch = useDebounce(searchVal, 500);
	const itemPerPage = 10;
	const userData = useSelector((state:any) => state?.mysession?.session);
	const navigation = useNavigate();
	const lastEleRef = useRef(null);
	const loaderRef = useRef(false);
	const location = useLocation();
	const currentCount = [ 'popularfeeds', 'bookmarks', 'myactivity', 'draft', 'pendingapproval' ].includes(type) || selectedActivity === 'pendingapproval'
		? count?.count
		: count?.feeds;
	const LoadMoreList = useInterSectionObserver({ lastEleRef, loaderRef, count: currentCount, data: feedList, setPage });
	const { feedAction, handleFeedAction, feedCardActn } = useContext(contextT === 'external' ? feedActionContextFromExternal : feedActionContext);
	const [ CreationPopupOpen, setCreationPopupOpen ] = useState(false);
	const isNewsPage = location.pathname === '/news';

	const getCount = useCallback(async (query:any, data:any) =>
	{
		if (page > 0) return; // not setting count for page greater than 0

		if (data.length < itemPerPage)
		{
			const newCount = [ 'bookmarks', 'popularfeeds', 'myactivity', 'draft' ].includes(type)
				? { count: data.length }
				: { feeds: data.length };

			setCount((prev) => ({ ...prev, ...newCount }));

			return;
		}

		if (type === 'draft')
		{
			query.feedCount = true;
		}
		else
		{
			query.count = true;
		}
		try
		{
			let res:any;

			if (type === 'bookmarks')
			{
				res = await getBookmarks(query);
			}
			else if (type === 'popularfeeds')
			{
				res = await getPopularFeeds(query);
			}
			else if (selectedActivity === 'pendingapproval' || type === 'pendingapproval')
			{
				res = await getPendingApprovalFeeds(query);
			}
			else
			{
				res = await getNewsFeeds(query);
			}

			if (res?.status)
			{
				const newCount = [ 'bookmarks', 'popularfeeds', 'myactivity', 'draft', 'pendingapproval' ].includes(type) || selectedActivity === 'pendingapproval'
					? { count: res?.count || 0 }
					: res?.response || {};

				setCount((prev) => ({ ...prev, ...(newCount || {}) }));
			}
		}
		catch (err)
		{
			catchErr(err);
		}
	}, [ page, type ]); // not passing count as dependency, prev will give the updated value
	const handleOpenCreation = () =>
	{
		setCreationPopupOpen(true);
	};
	const getNewsFeedList = useCallback(async () =>
	{
		setLoading(true);

		const baseQuery : any = {
			uid   : userData?.userId,
			comid : userData?.companyId,
			limit : itemPerPage,
			skip  : page
		};

		const query: any = {
			...baseQuery,
			empRole : userData?.empRole,
			role    : userData?.role,
			...(requestT?.type === 'my_profile'
				? { type: requestT?.empType }
				: { all: true })
		};

		if (debouncedSearch !== '')
		{
			query.searchKey = debouncedSearch;
			baseQuery.searchKey = debouncedSearch;
		}

		if (requestT?.type === 'draft')
		{
			query.isActive = false;
		}

		if (selectedFilter && Object.keys(selectedFilter).length > 0)
		{
			for (const key in selectedFilter)
			{
				query[key] = selectedFilter[key]?.join(',');
			}
			query.all = false;
		}

		if (selectedActivity) query.type = selectedActivity;

		try
		{
			// Always maintain userId with request type, when passing requestT props for fetching compnay or user feeds as external resource.
			const isProfileType = [ 'network_profile', 'business_profile', 'my_profile', 'connection' ].includes(requestT?.type);
			const queryType = isProfileType && requestT?.type !== 'my_profile' ? baseQuery : query;
			const res = isProfileType
				? await getFeedByCompanyId(requestT?.userId, queryType)
				: await getNewsFeeds(query);

			if (res?.status)
			{
				let newList = res?.response?.data || res?.data || [];
				const handleSearchFilterElement = document.getElementById('FeedTitleHeader');

				if (handleSearchFilterElement && searchVal === '' && Object.keys(selectedFilter || {}).length === 0 && page === 0)
				{
					handleSearchFilterElement.style.display = newList.length === 0 ? 'none' : '';
				}

				getCount(query, newList);
				loaderRef.current = newList?.length === 0; // to stop pagination if getting response empty arr.
				if (page !== 0) newList = [ ...feedList, ...newList ];
				setFeedList(newList);
			}
			else
			{
				// eslint-disable-next-line no-console
				console.error(res);
				loaderRef.current = false;
			}
		}
		catch (err)
		{
			// eslint-disable-next-line no-console
			console.log(err);
			toast.error(language.unableToLoadFeed);
			loaderRef.current = false;
		}
		finally
		{
			setLoading(false);
		}
	}, [ userData,
		page,
		requestT,
		selectedFilter,
		selectedActivity,
		debouncedSearch,
		feedList,
		getCount ]);

	const fetchListData = async (
		fetchFunction: (query: any) => Promise<any>,
		setLoadings: (loadings: boolean) => void,
		setFeedsList: (list: any[]) => void,
		getCounts: (query: any, list: any[]) => void,
		listPage: number,
		listItemPerPage: number,
		errorMessage: string
	) =>
	{
		setLoadings(true);

		const query: any = {
			skip    : listPage,
			limit   : listItemPerPage,
			uid     : userData?.userId,
			comid   : userData?.companyId,
			empRole : userData?.empRole,
			role    : userData?.role
		};

		if (debouncedSearch !== '')
		{
			query.searchKey = debouncedSearch;
		}

		try
		{
			const res = await fetchFunction(query);

			if (res?.status)
			{
				let newList: any = res?.data?.bookmarks || res?.data || [];

				getCounts(query, newList);

				if (page !== 0)
				{
					newList = [ ...feedList, ...newList ];
				}

				setFeedsList([ ...newList ]);
			}
			else
			{
				console.error(res);
			}
		}
		catch (err)
		{
			console.error('err');
			toast.error(errorMessage);
		}

		setLoadings(false);
	};

	// Usage for getBookmarkList
	const getBookmarkList = async () =>
	{
		await fetchListData(
			getBookmarks,
			setLoading,
			setFeedList,
			getCount,
			page,
			itemPerPage,
			'Unable to load bookmarks'
		);
	};

	// Usage for getPopularFeedsList
	const getPopularFeedsList = async () =>
	{
		await fetchListData(
			getPopularFeeds,
			setLoading,
			setFeedList,
			getCount,
			page,
			itemPerPage,
			'Unable to load popular feeds'
		);
	};

	// Get pending approval or rejected feeds
	const getPendingFeeds = async () =>
	{
		setLoading(true);

		const query: any = { status: [ 'pending', 'rejected' ].join(','), skip: page, limit: itemPerPage };

		if (debouncedSearch !== '')
		{
			query.searchKey = debouncedSearch;
		}

		try
		{
			const res = await getPendingApprovalFeeds(query);

			if (res?.status)
			{
				const newList = res?.data || [];

				page === 0
					? setFeedList(newList)
					: setFeedList([ ...feedList, ...newList ]);
				getCount(query, newList);
			}
			else
			{
				console.error(res);
				toast.error(language?.unableToLoadFeed);
			}
		}
		catch (err)
		{
			console.error(err);
			toast.error(language?.unableToLoadFeed);
		}
		finally
		{
			setLoading(false);
		}
	};

	const getApiList = () =>
	{
		if (page > 0) setPage(0);
		else if (selectedActivity === 'pendingapproval' || type === 'pendingapproval') getPendingFeeds();
		else if (type === 'bookmarks') getBookmarkList();
		else if (type === 'popularfeeds') getPopularFeedsList();
		else getNewsFeedList();
	};
	// calling this function to update the feedslist after deleting a post.
	const delCloseGetApi = (status = false) =>
	{
		if (status)
		{
			// calling get api after delete and reposting
			getApiList();
		}
	};

	useDidMountEffect(() =>
	{
		getApiList();
	}, [ selectedFilter, debouncedSearch, requestT ]);

	useEffect(() =>
	{
		if (selectedActivity === 'pendingapproval' || type === 'pendingapproval') getPendingFeeds();
		else if (type === 'bookmarks') getBookmarkList();
		else if (type === 'popularfeeds') getPopularFeedsList();
		else getNewsFeedList();
	}, [ page, type, selectedActivity ]);

	useEffect(() =>
	{
		LoadMoreList();
	}, [ lastEleRef, count, feedList ]);

	useEffect(() =>
	{
		if (feedAction?.bookmark_remove || feedAction?.bookmark_add)
		{
			let newArr = [];
			const id = feedAction?.bookmark_add ? feedAction?.bookmark_add?.feedId : feedAction?.bookmark_remove;

			if (type === 'bookmarks' && feedAction?.bookmark_remove)
			{
				newArr = feedList?.filter((feedItem) => feedItem?.feedId !== id);
			}
			else
			{
				newArr = feedList?.map((feedItem) =>
				{
					if (feedItem?._id === id) return { ...feedItem, bookMark: Boolean(feedAction?.bookmark_add) };
					else return feedItem;
				});
			}
			setFeedList([ ...newArr ]);
		}
		if (feedAction?.report_tag || feedAction?.remove_feed)
		{
			const delIndex = feedAction?.report_tag?.index ?? feedAction?.remove_feed?.index;
			let newArr = JSON.parse(JSON.stringify(feedList));

			if (Number.isInteger(delIndex)) newArr.splice(delIndex, 1); // removing feed
			else newArr = newArr.filter((feed) => feed?._id !== feedAction?.remove_feed?._id);
			setFeedList([ ...newArr ]);
			feedAction?.remove_feed && handleFeedAction('remove', 'remove_feed');
		}
		if (feedAction?.edit_feed)
		{
			const newArr = JSON.parse(JSON.stringify(feedList));

			setFeedList([ ...newArr ]);
		}
		if (feedAction?.new_feed?.index)
		{
			const newArr = JSON.parse(JSON.stringify(feedList));

			newArr.splice(feedAction?.new_feed?.index, 0, feedAction?.new_feed); // pathing feed at particular index
			setFeedList([ ...newArr ]);
			handleFeedAction('remove', 'new_feed');
		}
		else if (feedAction?.new_feed)
		{
			setFeedList((prev) => ([ feedAction.new_feed, ...prev ]));
			handleFeedAction('remove', 'new_feed');

			// after patching the feed supposed to set new_feed as null
		}

		else if (Number.isInteger(feedAction?.comments_add))
		{
			const newArr = feedList.map((feedItem, index) =>
			{
				const id = feedCardActn[1]?._id;

				if (feedItem?._id === id) return { ...feedItem, commentsCount: Number(feedAction?.comments_add) };
				else return feedItem;
			});

			setFeedList(newArr);
		}
	}, [ feedAction?.new_feed, feedAction?.report_tag, feedAction?.remove_feed, feedAction?.bookmark_remove, feedAction?.bookmark_add, feedAction?.comments_add, feedAction?.edit_feed ]);

	const selActObj = {
		selfFeed        : language?.noFeedsYet,
		tag             : language?.noTagYet,
		schedule        : language?.noScheduleYet,
		bookmarks       : language?.noBooksmarksYet,
		// feeds     : language?.nofeedsyet,
		feeds           : (userData?.empRole === 'employee' || requestT?.empType === 'employee') ? 'No posts yet! Share an update or follow companies to see their latest news and insights on your feed.' : (userData?.empRole === 'superAdmin' || userData?.empRole === 'admin') ? 'Your news feed is empty! Start by creating a post to update your employees or networks. You can also connect/follow companies to see their updates here.' : 'Your feed is empty! Follow companies to see their latest updates here',
		draft           : language?.noDraftYet,
		pendingapproval : language?.noPendingApprovalYet || 'No pending approval yet'
	};

	const handleEditedFeedUpdate = (feedObj) =>
	{
		const upadtedList = feedList?.map((each) =>
		{
			if (each?._id === feedObj?._id)
			{
				return { ...each, ...feedObj };
			}
			else
			{
				return each;
			}
		});

		setFeedList(upadtedList);
	};

	return (
		<Grid item width='98.5%' mx='auto'>
			{feedList?.length === 0 && !loading && (
				<Grid container flexDirection='column' display='flex' justifyContent='center' alignItems='center'
					sx={{
						height : from === 'network_profile' || from === 'business_profile' ? '60vh' : '100%'
					}}
				>
					<NoData
						noDataHead={from !== 'network_profile' && (requestT?.userId !== userData?.userId) ? '' : `Hi ${userFullName(userData)}`}
						src1={FeedNodataImg}
						heightimg='var(--font200)'
						className='alignCntr justifyCntr'
					/>
					{
						requestT?.type !== 'network_profile' && (
							<>

								<Typography pb='var(--pixel16)' variant='body2' color='#737373'>
									{selActObj[type]}
									{selectedActivity && selActObj[selectedActivity]}
								</Typography>
								{(selectedActivity === 'selfFeed' || isNewsPage) && <Stack direction='row' spacing={1}>
									<Button
										variant='contained'
										sx={{ color: 'var(--whiteColor)' }}
										endIcon={<FaPlus fontSize='var(--pixel16)' />}
										onClick={handleOpenCreation}
									>
										Create Feeds
									</Button>
									{/* {!type && */}
									<Button
										variant='contained'
										sx={{ color: 'var(--whiteColor)' }}
										endIcon={<FaPlus fontSize='var(--pixel16)' />}
										onClick={() => navigation('/connections')}
									>
										{language.network}
									</Button>
								</Stack>}
							</>
						)
					}
				</Grid>
			)}
			{feedList?.map((item:any, index:any) =>
				(
					<>
						<FeedCard
							key={`${item?._id}?unqK${item?.postedAt}`}
							item={item}
							index={index}
							scheduled={scheduled}
							delCloseGetApi={delCloseGetApi}
							from={from}
							contextT={contextT}
							requestT={requestT}
							selectedActivity={selectedActivity}
							handleEditedFeedUpdate={handleEditedFeedUpdate}
						/>
						{index === feedList?.length - 2 && <span ref={lastEleRef}/>}
					</>
				))
			}
			{loading && <NewsFeedShimmer/>}
			{CreationPopupOpen && <CreationFieldPopUp OpenPop={CreationPopupOpen} handleClosePop={() => setCreationPopupOpen(false)}/>}

		</Grid>
	);
};

export default memo(FeedCards);